import React from 'react';
import HTML from '../HtmlHelpers';
import CurrencyLabel from "../../components/CurrencyLabel/CurrencyLabel";
import {getSetting} from "../LocalSettings/LocalSettings";
import {removeToast, toast} from '../../react-notifications';
import TractorRequestNotification from "./PopupTemplates/TractorRequestNotification";
import PaymentInfoTemplate from "./PopupTemplates/PaymentInfoTemplate";
import NewOperatorRequestTemplate from "./PopupTemplates/NewOperatorRequestTemplate";
import UserRegistrationTemplate from "./PopupTemplates/UserRegistration";
import { Howl } from 'howler';

/**
 * Shows popup
 * @param {String} type
 * @param {Function} content
 */
const showPopup = (type,content) => {

    let id;
    toast(content({ onClick: () => removeToast(id) }),{
        appearance: type,
        placement: 'top-right',
        autoDismiss: getSetting('auto_dismiss_popup')
    }, params => id = params);

    //  play notification sound
    if(getSetting('enable_sounds',false)){

        const sound = new Howl({
            src: ['/sounds/request_notification_sound.mp3'],
            volume: 0.8
        });

        sound.play();
    }

};


/**
 * POPUP NOTIFICATION HELPER
 * Description:
 * Shows popup notifications for user
 */
class UserNotifications {

    /**
     * Shows account activation complete toast
     */
    static showActivationComplete() {
        HTML.toastMessage('Activation completed successfully');
    }

    /**
     * Shows a concurrent change of resource error
     */
    static showConcurrentUpdateError(){
        HTML.toastWarning( 'Update Error: Seems the record has changed! Please refresh page' );
    }

    /**
     * Notifies the user of a new tractor request
     * @param request
     */
    static notifyNewTractorRequest(request){

        showPopup('info',props => <TractorRequestNotification title="New Tractor Request"
                                                              request={request}
                                                              fields={[ "id", "name" , "location" , "service" , "cost" ]}
                                                              {...props}
                                                            />);
    }


    /**
     * Notifies the user of a new tractor request
     * @param request
     */
    static notifyRequestStarted(request){

        showPopup('info',props => <TractorRequestNotification title="Request Started"
                                                              request={request}
                                                              fields={[ "id" , "date_started" ]}
                                                              {...props}/>);

    }

    static notifyRequestAssigned(request){

        showPopup('info',props => <TractorRequestNotification title="Request Assigned"
                                                              request={request}
                                                              fields={["id", "name", "location" , "service"]}
                                                              {...props}/>);
    }

    static notifyRequestCompleted(request){

        showPopup('success',props => <TractorRequestNotification title="Request Completed"
                                                                 request={request}
                                                                 fields={[ "id" , "name", "location" , "service" , "cost" ]}
                                                                 {...props}/>);

    }

    static notifyRequestCancelled(request){

        showPopup('info',props => <TractorRequestNotification title="Request Cancelled"
                                                               request={request}
                                                               fields={[ "id", "name", "location" , "service" , "cost" ]}
                                                               {...props}/>);
    }

    /**
     * Notify the user of a new tractor request payment
     */
    static notifyTractorRequestPayment(request){

        showPopup('success',props => <TractorRequestNotification request={request}
                                                                 hint={request => <div>
                                                                     <p>Payment of <CurrencyLabel currency={request.txn_currency} value={request.cost}/> has been made successfully for a tractor request</p>
                                                                     <b>Request Details</b>
                                                                 </div>}
                                                                 fields={[ "id", "name" , "service" ]}
                                                                 {...props}/>);
    }

    /**
     * Notify payment received
     * @param payment
     */
    static notifyPaymentReceived(payment){

        showPopup('info',props => <PaymentInfoTemplate title={"Payment Received"} payment={payment}
                                                       {...props}/>)

    }

    /**
     * New Operator Registration
     * @param request
     */
    static notifyOperatorRegistration(request){

        showPopup('info', props => <NewOperatorRequestTemplate request={request} {...props}/>)
    }

    /**
     * New User Registration
     * @param payload
     */
    static notifyNewUserRegistration(payload){
        showPopup('info', props => <UserRegistrationTemplate payload={payload} {...props} />)

    }
}

export default UserNotifications;


// WEBPACK FOOTER //
// ./src/common/UserNotifications/UserNotifications.js